import React, { useEffect, useState } from "react";

function NewStatement({
    type = "other",
    actions,
    msg,
    caption,
    setModal,
    departments,
    cashAccounts,
    articles,
    counterparties,
    userCashAccount,
}) {
    const [relatedData, setRelatedData] = useState([]);
    const [relatedDataLabel, setRelatedDataLabel] = useState("");
    const [amount, setAmount] = useState("0");

    const [selectedArticle, setSelectedArticle] = useState("");
    const [selectedOperation, setSelectedOperation] = useState("");
    const [selectedRelatedData, setSelectedRelatedData] = useState("");

    useEffect(() => {
        const operationsMap = {
            OtherAdmission: "9",
            OtherExpense: "8",
            _Transfer: "3",
            Transfer: "3",
            SupplierPayment: "1",
        };
        setSelectedOperation(operationsMap[type] || "");
    }, [type]);

    useEffect(() => {
        const relatedDataMap = {
            1: { data: counterparties, label: "Контрагент" },
            3: { data: cashAccounts.filter((value) => value.id !== userCashAccount), label: "Каса/Рахунок" },
            8: { data: departments, label: "Підрозділ" },
            9: { data: departments, label: "Підрозділ" },
        };
        const { data = [], label = "" } =
            relatedDataMap[selectedOperation] || {};

        setRelatedData(data);
        setRelatedDataLabel(label);
    }, [selectedOperation, counterparties, cashAccounts, departments, userCashAccount]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setModal("");
        const data = {
            account: userCashAccount || null,
            operation: selectedOperation,
            correspond: selectedRelatedData,
            article: selectedArticle,
            amount:
                amount[amount.length - 1] === "."
                    ? amount.slice(0, amount.length - 1)
                    : amount,
        };
        if(type==='_Transfer'){
            data.account=selectedRelatedData
            data.correspond=userCashAccount || null
        }

        actions.loaddata(
            "action=addStatementItem&data=" + JSON.stringify(data),
            undefined,
            (d) => {
                if (d.status === "success") {
                    msg("Операція успішна", "Повідомлення");
                } else {
                    msg(d.message, "Помилка");
                }
            }
        );
    };

    const buttons = [
        ["7", "8", "9"],
        ["4", "5", "6"],
        ["1", "2", "3"],
        ["0", ".", "⌫"],
    ];

    const handleKeyPress = (key) => {
        if (key === "⌫") {
            setAmount((prev) => (prev.length > 1 ? prev.slice(0, -1) : "0"));
        } else if (key === "." && amount.includes(".")) {
            return;
        } else if (!isNaN(key) || key === ".") {
            setAmount((prev) =>
                prev === "0" && key !== "." ? key : prev + key
            );
        }
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        if (/^\d*\.?\d*$/.test(value)) {
            setAmount(value);
        }
    };

    const handleKeyboardKeyPress = (e) => {
        if (e.key === "Backspace") {
            setAmount((prev) => (prev.length > 1 ? prev.slice(0, -1) : "0"));
        } else if (/^\d$/.test(e.key) || e.key === ".") {
            if (e.key === "." && amount.includes(".")) {
                return;
            }
            setAmount((prev) => (prev === "0" ? e.key : prev + e.key));
        }
        e.preventDefault();
    };

    let pos1 = 0,
        pos2 = 0,
        pos3 = 0,
        pos4 = 0;

    function dragMouseDown(e) {
        e = e || window.event;
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
        const elmnt = document.getElementById("calc");
        e = e || window.event;
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        if (pos2 !== 0) elmnt.style.top = elmnt.offsetTop - pos2 + "px";
        if (pos1 !== 0) elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
    }

    function closeDragElement() {
        /* stop moving when mouse button is released:*/
        document.onmouseup = null;
        document.onmousemove = null;
    }

    return (
        <div className="modal">
            <div className="window" id="calc">
                <div
                    onMouseDown={dragMouseDown}
                    style={{
                        flexDirection: "row",
                        display: "flex",
                        justifyContent: "flex-start",
                    }}
                >
                    <div className="caption">{caption || null}</div>
                    <div
                        className="closebtn"
                        onClick={() => {
                            setModal("");
                        }}
                    />
                </div>
                <div className="content">
                    <form onSubmit={handleSubmit} style={{ margin: "5px" }}>
                        <div style={{ marginTop: "4px" }}>
                            <label>Стаття:</label>
                            <select
                                className="statement--input"
                                value={selectedArticle}
                                onChange={(e) =>
                                    setSelectedArticle(e.target.value)
                                }
                            >
                                <option value="" disabled>
                                    Виберіть статтю
                                </option>
                                {articles.map((article) => (
                                    <option key={article.id} value={article.id}>
                                        {article.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {selectedOperation && relatedData.length > 0 && (
                            <div style={{ marginTop: "4px" }}>
                                <label>{relatedDataLabel}</label>
                                <select
                                    className="statement--input"
                                    value={selectedRelatedData}
                                    onChange={(e) =>
                                        setSelectedRelatedData(e.target.value)
                                    }
                                    required
                                >
                                    <option value="" disabled>
                                        Виберіть
                                    </option>
                                    {relatedData.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        <div style={{ marginTop: "4px" }}>
                            <label>Сума:</label>
                            <input
                                className="statement--input"
                                style={{
                                    fontWeight: "bold",
                                }}
                                type="text"
                                value={amount}
                                onKeyDown={handleKeyboardKeyPress}
                                onChange={handleInputChange}
                                required
                            />
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(3, 1fr)",
                                    marginTop: "5px",
                                    marginBottom: "5px",
                                    marginLeft: "10px",
                                }}
                            >
                                {buttons.flat().map((button) => (
                                    <div
                                        className="login_btn"
                                        key={button}
                                        onClick={() => handleKeyPress(button)}
                                        style={{
                                            height: "48px",
                                            lineHeight: "48px",

                                            width: "48px",
                                        }}
                                    >
                                        {button}
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <button
                                type="submit"
                                className="ord_button2 toolBarItem2"
                                style={{
                                    width: "84px",
                                    height: "39px",
                                    lineHeight: "32px",
                                }}
                            >
                                {type === "sdPayment" ? "Оплатити" : "Додати"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default NewStatement;
